import { ReferencialData } from "../../domain";

export class PatientObjective {
  id: number;
  patientId: number;
  objetiveTargetEnum: string;
  visionPatient: number;
  observation: string;
  objetiveCC: ReferencialData;
}
